export const DEALER_STATUSES = [
  "prospect",
  "onboarding",
  "active",
  "paused",
  "suspended",
  "rejected",
  "archived",
];

export const VERIFICATION_STATUSES = [
  "unverified",
  "pending",
  "verified",
  "rejected",
  "suspended",
];

export const TRIAL_STATUSES = [
  "not_started",
  "active",
  "ending_soon",
  "expired",
  "converted",
  "declined",
];

export const PLAN_TYPES = ["founding_free", "free", "starter", "growth", "premium"];

export const INVENTORY_FORMATS = ["spreadsheet", "website", "manual", "other"];

export const PROSPECT_STATUSES = [
  "new",
  "contacted",
  "qualified",
  "converted_to_dealer",
  "not_fit",
  "archived",
];

export const NOTE_TYPES = [
  "general",
  "sales",
  "onboarding",
  "support",
  "verification",
  "trial",
  "risk",
];

export const DEALER_USER_ROLES = [
  "owner",
  "manager",
  "salesperson",
  "inventory_manager",
  "viewer",
];

export const DEALER_USER_STATUSES = ["invited", "active", "disabled"];

export const VERIFICATION_CHECKLIST_ITEMS = [
  { key: "businessNameConfirmed", label: "Nombre comercial confirmado", required: true },
  { key: "physicalAddressConfirmed", label: "Dirección física confirmada", required: true },
  { key: "whatsappConfirmed", label: "WhatsApp confirmado", required: true },
  { key: "contactPersonConfirmed", label: "Contacto confirmado", required: true },
  { key: "inventorySourceConfirmed", label: "Fuente de inventario confirmada", required: true },
  { key: "websiteSocialReviewed", label: "Web/redes revisadas", required: false },
  { key: "financingClaimReviewed", label: "Financiación revisada (si aplica)", required: false },
  { key: "publicProfileReviewed", label: "Perfil público revisado", required: false },
];

export const DEALER_SORT_OPTIONS = [
  { value: "recently_created", label: "Recién creados" },
  { value: "last_activity", label: "Última actividad" },
  { value: "active_listings", label: "Listings activos" },
  { value: "leads_received", label: "Leads recibidos" },
  { value: "trial_ending_soon", label: "Trial por vencer" },
  { value: "dealer_name", label: "Nombre" },
];

export const PROSPECT_STATUS_LABELS = {
  new: "Nuevo",
  contacted: "Contactado",
  qualified: "Calificado",
  converted_to_dealer: "Convertido",
  not_fit: "No califica",
  archived: "Archivado",
};

export const NOTE_TYPE_LABELS = {
  general: "General",
  sales: "Ventas",
  onboarding: "Onboarding",
  support: "Soporte",
  verification: "Verificación",
  trial: "Trial",
  risk: "Riesgo",
};

export const USER_ROLE_LABELS = {
  owner: "Dueño",
  manager: "Gerente",
  salesperson: "Vendedor",
  inventory_manager: "Inventario",
  viewer: "Solo lectura",
};

export function formatProspectStatus(status) {
  return PROSPECT_STATUS_LABELS[status] || status || "—";
}

export const LISTING_CHANNELS = [
  "tucarro",
  "mercado_libre",
  "facebook_marketplace",
  "instagram",
  "own_website",
  "other",
];

export const STATUS_LABELS = {
  prospect: "Prospecto",
  onboarding: "Onboarding",
  active: "Activo",
  paused: "Pausado",
  suspended: "Suspendido",
  rejected: "Rechazado",
  archived: "Archivado",
  unverified: "Sin verificar",
  pending: "Pendiente",
  verified: "Verificado",
  not_started: "Sin iniciar",
  ending_soon: "Por vencer",
  expired: "Vencido",
  converted: "Convertido",
  declined: "Declinado",
};

export function formatDealerStatus(status) {
  return STATUS_LABELS[status] || status || "—";
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-CO", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}
